import { useEffect, useState } from "react";
import { supportsWorkspaceScreen } from "./workspaceScreen";

function readScreen() {
  return supportsWorkspaceScreen(window.innerWidth, window.screen?.width ?? 0);
}

export function useWorkspaceScreen() {
  const [supported, setSupported] = useState(readScreen);
  useEffect(() => {
    const update = () => setSupported(readScreen());
    window.addEventListener("resize", update);
    window.screen?.orientation?.addEventListener("change", update);
    update();
    return () => {
      window.removeEventListener("resize", update);
      window.screen?.orientation?.removeEventListener("change", update);
    };
  }, []);
  return supported;
}
